import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03816b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color-picker-container" }


const __default__ = {
  name: 'ColorPicker'
}

import Color from 'color'
import { ref, watch } from 'vue'
import ColorPanel from './colorPanel/index.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: null
  },
  emits: ['update:color'],
  setup(__props: any, { emit }) {

const props = __props as { color: string }





const displayedAlphaRef = ref<number>(1)
const color = ref(props.color)

watch(
  () => props.color,
  val => {
    try {
      const value = Color(val)
      color.value = value.hexa()
      displayedAlphaRef.value = value.alpha()
    } catch (error) {
      color.value = ''
      displayedAlphaRef.value = 1
    }
  },
  {
    immediate: true
  }
)

const updateColor = (val: string, alpha: number) => {
  color.value = val
  displayedAlphaRef.value = alpha
}

const onUpdateColor = (val: string) => {
  const value = Color(val)
  updateColor(value.hexa(), value.alpha())
  emit('update:color', val)
}

return (_ctx: any,_cache: any) => {
  const _component_n_popover = _resolveComponent("n-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_popover, {
      class: "color-picker-popup",
      placement: "bottom",
      "show-arrow": false,
      trigger: "click",
      style: {"width":"240px"}
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", {
          class: "swatch",
          style: _normalizeStyle({ background: color.value })
        }, null, 4)
      ]),
      default: _withCtx(() => [
        _createVNode(ColorPanel, {
          color: color.value,
          "onUpdate:color": onUpdateColor
        }, null, 8, ["color"])
      ]),
      _: 1
    })
  ]))
}
}

})